import { render } from "./Comment.vue?vue&type=template&id=0bf7ff84&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"

import "./Comment.vue?vue&type=style&index=0&id=0bf7ff84&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bf7ff84"

export default script